function requestAuth(url, param) {
  return window.sendRequestAuth(url, param);
}

function request(url, param) {
  return window.sendRequest(url, param);
}

export function getSchoolList() {
  return requestAuth('/get_school_list', {});
}

export function getClassList(schoolId) {
  return requestAuth('/get_class_list', { school_id: schoolId });
}

export function getSchoolListOrder() {
  return requestAuth('/get_school_list_order', {});
}

export function getClassListOrder(schoolId) {
  return requestAuth('/get_class_list_order', { school_id: schoolId });
}

export function getSeloSchool(schoolId) {
  return requestAuth('/get_selo_school', { school_id: schoolId });
}

export function getClosedSchool(schoolId) {
  return requestAuth('/get_closed_school', { school_id: schoolId });
}

export function getLastOrders() {
  return requestAuth('/get_last_orders', {});
}

export function getOrderFood(param) {
  return requestAuth('/get_order_food', param);
}

export function saveOrderFood(param) {
  return requestAuth('/save_order_food', param);
}

export function refreshStudents(param) {
  return requestAuth('/refresh_students', param);
}

export function getControlOrderFood(param) {
  return requestAuth('/get_control_order_food', param);
}

export function getGosMoney(param) {
  return requestAuth('/get_gos_money', param);
}

export function getParentMoney(param) {
  return requestAuth('/get_parent_money', param);
}

export function getTabelLgota(param) {
  return requestAuth('/get_tabel_lgota', param);
}

export function getTabelFree(param) {
  return requestAuth('/get_tabel_free', param);
}

export function getTabelFreeFood(param) {
  return requestAuth('/get_tabel_free_food', param);
}

export function getOtchet(param) {
  return requestAuth('/get_otchet', param);
}

export function getOtchetOptions() {
  return requestAuth('/get_otchet_options', {});
}

export function getOtchetStudent(param) {
  return requestAuth('/get_otchet_student', param);
}

export function getOtchetTypeLgota(param) {
  return requestAuth('/get_otchet_type_lgota', param);
}

export function getTypeLgotaList() {
  return requestAuth('/get_type_lgota_list', {});
}

export function getLgotaList(param) {
  return requestAuth('/get_lgota_list', param);
}

export function addLgota(param) {
  return requestAuth('/add_lgota', param);
}

export function removeLgota(param) {
  return requestAuth('/remove_lgota', param);
}

export function getUserInfo() {
  return requestAuth('/get_user_info', {});
}

export function getNotice() {
  return requestAuth('/get_notice', {});
}

export function viewNotice(notificationId) {
  return requestAuth('/view_notice', { notification_id: notificationId });
}

export function getStudentsPay() {
  return requestAuth('/get_students_pay', {});
}

export function transferCash(param) {
  return requestAuth('/transfer_cash', param);
}

export function getFinance(param) {
  return requestAuth('/get_finance', param);
}

export function resetPass(param) {
  return requestAuth('/reset_pass', param);
}

export function searchStudent(param) {
  return requestAuth('/search_student', param);
}

export function addChild(param) {
  return requestAuth('/add_child', param);
}

export function updateTime(param) {
  return requestAuth('/update_time', param);
}

export function getUserLk() {
  return requestAuth('/get_user_lk', {});
}

export function updateBufet(param) {
  return requestAuth('/update_bufet', param);
}

export function updatePhoto(param) {
  return requestAuth('/update_photo', param);
}

export function pay(param) {
  return requestAuth('/pay', param);
}

export function payTest(param) {
  return requestAuth('/pay_test', param);
}

export function payUKassaTest(param) {
  return requestAuth('/pay_u_kassa_test', param);
}

export function getGeneralImg() {
  return request('/get_general_img', {});
}

export function getNews(param) {
  return request('/get_news', param);
}

export function getMenuTitle() {
  return request('/get_menu_title', {});
}

export function getMenuList(param) {
  return request('/get_menu_list', param);
}

export function getRunLine() {
  return request('/get_run_line', {});
}

export function getShops() {
  return request('/get_shops', {});
}

export function getNew(newId) {
  return request('/get_new', { new_id: newId });
}

export function auth(param) {
  return request('/auth', param);
}

export function resetLogin(param) {
  return request('/reset_login', param);
}

export function register(param) {
  return request('/register', param);
}

export function resetPassPublic(param) {
  return request('/reset_pass', param);
}

export function checkLs(numLs) {
  return request('/check_ls', { num_ls: numLs });
}

export function payPublic(param) {
  return request('/pay', param);
}

export function payTestPublic(param) {
  return request('/pay_test', param);
}

export function payUKassaTestPublic(param) {
  return request('/pay_u_kassa_test', param);
}
